
import { Box, Stack, Container } from '@mui/material'
import { Redirect, Route, Switch, useLocation } from 'react-router-dom'

import { BookingTrackingPage } from 'components/booking-tracking'
import { TrustpilotBox } from 'components/common'
import { Paths } from 'constants/index'

import { AuthFooter, AuthHeader } from './common'
import { SingUpPage } from './SignUpPage'
import { WelcomePage } from './WelcomePage'

const Auth = () => {
  const location = useLocation()

  const isTrackingPage = location.pathname.includes('/live-tracking/')

  return (
    <Stack>
      {!isTrackingPage && <AuthHeader />}

      <Switch>
        <Route path={Paths.trackingPage} component={BookingTrackingPage} />
        <Route path={Paths.auth.welcome} component={WelcomePage} />

        <Route path={Paths.auth.signUp} component={SingUpPage} />

        <Route path='/' exact>
          <Redirect to={Paths.auth.welcome} />
        </Route>

        <Route path='' component={WelcomePage} />
      </Switch>

      {!isTrackingPage && (
        <>
          <Container maxWidth='lg'>
            <Box marginY={6} marginX={3}>
              <TrustpilotBox />
            </Box>
          </Container>

          <AuthFooter />
        </>
      )}
    </Stack>
  )
}

export default Auth
